import React from 'react';
import { motion } from 'framer-motion';
import './Experience.css';

const experiences = [
  {
    role: 'Senior Developer',
    company: 'Company Name',
    period: '2023 — Present',
    description: 'Leading the development of scalable web applications and mentoring junior developers. Driving technical decisions and architecture.',
    tags: ['Leadership', 'Architecture', 'React'],
  },
  {
    role: 'Full Stack Developer',
    company: 'Company Name',
    period: '2021 — 2023',
    description: 'Built and maintained multiple client-facing applications. Improved performance by 40% through optimization and modern tech stack adoption.',
    tags: ['Full Stack', 'Node.js', 'PostgreSQL'],
  },
  {
    role: 'Frontend Developer',
    company: 'Company Name',
    period: '2019 — 2021',
    description: 'Developed responsive web interfaces and component libraries. Collaborated closely with design teams to implement pixel-perfect UIs.',
    tags: ['Frontend', 'UI/UX', 'Design Systems'],
  },
];

function Experience() {
  return (
    <section className="experience section-padding" id="experience">
      <div className="container">
        <motion.div
          className="experience__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">Experience</span>
          <h2 className="section-title">
            Where I've made<br />
            <span className="text-gradient">an impact</span>
          </h2>
        </motion.div>

        <div className="experience__timeline">
          {experiences.map((exp, i) => (
            <motion.div
              key={exp.role + exp.company}
              className="experience__item"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: 0.15 * i }}
            >
              <div className="experience__dot" />
              <div className="experience__content">
                <div className="experience__meta">
                  <span className="experience__period">{exp.period}</span>
                </div>
                <h3 className="experience__role">{exp.role}</h3>
                <p className="experience__company">{exp.company}</p>
                <p className="experience__desc">{exp.description}</p>
                <div className="experience__tags">
                  {exp.tags.map((tag) => (
                    <span key={tag} className="experience__tag">{tag}</span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
